export const GET_CT_PAGES = 'GET_CT_PAGES'
export const GET_CT_PAGES_SUCCESS = 'GET_CT_PAGES_SUCCESS'
export const GET_CT_PAGES_FAILURE = 'GET_CT_PAGES_FAILURE'
